import { call, put } from 'redux-saga/effects'
import api from './../../utils/api'
import actions from './actions'

const queryFireRollCall = (code, siteType) => call(api.getFireRollCall, code, siteType)

function* fetchFireRollCall(action = {}) {
  yield put({ type: actions.fetchPending })
  let fireRollCall
  try {
    fireRollCall = yield queryFireRollCall(action.site.code, action.site.sitetype)
  } finally {
    yield put({ type: actions.setFireRollCall, fireRollCall })
  }
}

export default fetchFireRollCall



// WEBPACK FOOTER //
// ./src/store/fire-roll-call/saga.js